import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import {withStyles} from "@material-ui/core";

const DynamicLegendContainer = styled.div`
	user-select: none;
	position: relative;
	background: white;
	height: auto;
	z-index: 20;
	padding: 8px;
`;

const SpaceBetweenCenterContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

const GradientContainer = styled.div`
	width: 100%;
	height: 20px;
	border: 1px solid #ced6e0;
	background-image: ${props =>
		`linear-gradient(to right, white, rgba(${props.color
			.slice(0, 3)
			.join(", ")}, ${props.maxOpacity}))`};
	border-radius: 4px;
`;

const styles = theme => ({
    typography: {
        marginTop: '0.8em',
    }
});

class DynamicLegend extends Component {
	render() {
		const {
			id,
			title,
			description,
			color,
			minLegendDescription,
			maxLegendDescription,
			maxOpacity,
		} = this.props;

        const {classes} = this.props;
		return (
			<DynamicLegendContainer>
				<SpaceBetweenCenterContainer>
					<Typography variant="h6">
						{title} {id === "fibre_dediee" && ("*")}
					</Typography>
				</SpaceBetweenCenterContainer>
				<GradientContainer color={color} maxOpacity={maxOpacity} />
				<SpaceBetweenCenterContainer>
					<Typography variant="caption">
						{minLegendDescription}
					</Typography>
					<Typography variant="caption">
						{maxLegendDescription}
					</Typography>
				</SpaceBetweenCenterContainer>
				<Typography variant="body2" className={classes.typography}>{description}</Typography>
				{id === "fibre_dediee" && (
					<Typography variant="caption" style={{fontStyle: 'italic'}}>
						* Offre fibre dédiée proposée par le réseau{" "}
						<a
							href="https://www.celeste.fr/"
							rel="noopener noreferrer"
							target="_blank"
						>
							CELESTE
						</a>
					</Typography>
				)}
			</DynamicLegendContainer>
		);
	}
}

DynamicLegend.propTypes = {
	title: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	color: PropTypes.array.isRequired,
	minLegendDescription: PropTypes.string.isRequired,
	maxLegendDescription: PropTypes.string.isRequired,
	maxOpacity: PropTypes.number.isRequired
};

export default withStyles(styles)(DynamicLegend);